import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import {
  ROUTE_META,
  getCanonicalUrl,
  getOgImageUrl,
  DEFAULT_OG_IMAGE,
} from "@/lib/seo";

/**
 * SPA-aware per-route meta: title, description, canonical, og, twitter.
 * Renders nothing; only updates document head. Use inside HelmetProvider.
 */
export function PageMeta() {
  const { pathname } = useLocation();
  const meta = ROUTE_META[pathname];

  if (!meta) return null;

  const canonicalUrl = getCanonicalUrl(meta.canonicalPath);
  const ogImage = getOgImageUrl(meta.canonicalPath);

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={canonicalUrl} />
      {meta.noindex && <meta name="robots" content="noindex, follow" />}

      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
    </Helmet>
  );
}
